import React, { CSSProperties } from 'react'
import './style.scss'

type ButtonColors =
  | 'primary'
  | 'primary-inverted'
  | 'primary-underlined'
  | 'default'
  | 'default-dashed'
  | 'default-underlined'
  | 'green'
  | 'green-inverted'
  | 'green-underlined'
  | 'blue'
  | 'red'
  | 'red-inverted'

type Props = {
  style?: CSSProperties
  type?: 'button' | 'submit' | 'reset'
  label?: any
  rounded?: boolean
  active?: boolean
  disabled?: boolean
  icon?: React.ReactNode
  color: ButtonColors
  onClick: () => void
  labelPostion?: 'middle'
  hideLabelOnMobile?: boolean
  className?: string
  stickers?: any[]
}

const Button = (props: Props) => {
  let classes = 'c-button'

  if (props.color) {
    classes += ' s-color-' + props.color
  }

  if (props.active) {
    classes += ' s-active'
  }

  if (props.hideLabelOnMobile) {
    classes += ' s-hide-label-on-mobile'
  }

  if (props.disabled) {
    classes += ' s-disabled'
  }

  if (props.className) {
    classes += ' ' + props.className
  }

  if (props.rounded) {
    classes += ' ' + 's-rounded'
  }

  let iconClass = 'c-button__icon'

  if (props.label) {
    iconClass += ' s-label-exists'
  }

  if (props.labelPostion) {
    classes += ' s-label-middle'
  }

  return (
    <button disabled={props.disabled} type={props.type ? props.type : 'button'} className={classes} onClick={() => props.onClick()} style={props.style || {}}>
      {props.icon && <div className={iconClass}>{props.icon} </div>}
      {props.label && <div className="c-button__label"> {props.label} </div>}
      {props.stickers && (
        <div className="c-button__stickers">
          {props.stickers.map((item) => (
            <div className="c-button__sticker">{item}</div>
          ))}
        </div>
      )}
    </button>
  )
}

type ButtonGroupProps = {
  children: React.ReactNode | React.ReactNode[]
  margin?: 'm'
  style?: CSSProperties
  className?: string
}

Button.ButtonGroup = (props: ButtonGroupProps) => {
  let classes = 'c-button-group'

  if (props.className) {
    classes += ' ' + props.className
  }

  if (props.margin) {
    switch (props.margin) {
      case 'm':
        classes += ' s-margin-m'
        break

      default:
        break
    }
  }

  return (
    <div className={classes} style={props.style || {}}>
      {props.children}
    </div>
  )
}

export default Button
